import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';

const Container = styled.div`
  min-height: 100vh;
  background-color: #f5f5f7;
  padding: 2rem;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex: 1;
`;

const Title = styled.h1`
  color: #1d1d1f;
  margin-bottom: 2rem;
  font-size: 2rem;
  text-align: center;
`;

const MarkdownContainer = styled.section`
  margin-bottom: 2rem;
  h1 {
    color: #1d1d1f;
    margin-bottom:0.5rem;
    font-size: 1.5rem;
  }
  h2 {
    color: #1d1d1f;
    margin-bottom: 0.5rem;
    font-size: 1.0rem;
  }

  p {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }
`;

const Footer = styled.footer`
  text-align: center;
  padding: 1rem 0;
  color: #86868b;
  font-size: 0.9rem;
`;

function ImgConvertPrivacyPolicyZhCn() {
  const currentYear = new Date().getFullYear();
  const markdownContent = `
 # 隐私政策

"图片格式转换应用"（以下简称"本应用"）尊重用户的隐私，并最大限度地注意保护个人信息。本应用不收集用户的个人信息，并采取措施保护用户的数据。本隐私政策（以下简称"本政策"）规定了本应用中信息的处理方式。

## 第1条（个人信息的收集和管理方针）

本应用不收集用户的任何个人信息（如姓名、地址、电话号码等）。应用内的所有功能都是在不收集个人信息的前提下设计的。此外，为了保护用户的隐私，我们根据个人信息保护法，不收集或存储任何可以识别个人身份的信息。

## 第2条（图片数据的处理）

在本应用中，用户转换的所有图片数据仅在用户设备内处理，不会传输到外部服务器。图片转换处理完全在本地进行，转换前后的图片数据仅保存在设备中。我们无法访问用户的图片数据。

## 第3条（广告投放）

本应用通过Google AdMob投放广告。在广告投放过程中，Google的系统可能会自动收集数据以优化广告投放，但这些数据按照Google的隐私政策进行管理。本应用不保留任何与广告投放相关的个人信息。详情请参阅Google的隐私政策。

## 第4条（隐私政策的变更）

本应用可能会不时审查本政策的内容，并根据法律修订和应用功能的变更来改变本政策，以提高用户隐私保护。当发生变更时，我们将通过在本应用内发布最新的隐私政策来通知用户，并在发布的同时生效。请用户定期查看本政策。

## 第5条（联系方式）

如果您对本政策有任何问题或疑虑，请通过以下地址与我们联系：

电子邮箱：linappworks@gmail.com
  `;

  return (
    <Container>
      <Content>
        <Title>Privacy Policy</Title>
        <MarkdownContainer>
          <ReactMarkdown>{markdownContent}</ReactMarkdown>
        </MarkdownContainer>
      </Content>
      <Footer>
        <p>© {currentYear} linappworks. All rights reserved.</p>
        <p>Contact us: linappworks@gmail.com</p>
      </Footer>
    </Container>
  );
}

export default ImgConvertPrivacyPolicyZhCn; 
